import React, { useRef, useState } from 'react';
import FlexContainer from '../../Containers/FlexContainer/FlexContainer.mjs';
import TextComponent from '../../Typography/Text/Text.mjs';
import { SearchButton } from '../Search/Search.styles.mjs';
import { StyledSearchHeaderForm, StyledSearchHeaderField, StyledSearchHeaderClearButton } from './SearchHeader.styles.mjs';
import { useTheme } from 'styled-components';

const SearchHeader = ({ searchTerm, searchResultsAmount, fieldPlaceholder = 'Search News12', onClear, onSearch }) => {
    const theme = useTheme();
    const searchFieldRef = useRef(null);
    const [searchTermText, setSearchTermText] = useState(searchTerm);
    const [isTouched, setIsTouched] = useState(false);
    const resultsCountText = Boolean(searchResultsAmount)
        ? `${searchResultsAmount} ${searchResultsAmount === 1 ? 'result' : 'results'}`
        : 'No results';
    const handleSearchChange = (event) => {
        setSearchTermText(event.target.value);
        setIsTouched(true);
    };
    const handleClearClick = () => {
        setSearchTermText('');
        setIsTouched(true);
        searchFieldRef.current && searchFieldRef.current.focus();
        onClear && onClear();
    };
    const handleSubmit = (event) => {
        event.preventDefault();
        onSearch(searchTermText);
    };
    return (React.createElement(FlexContainer, { direction: "column", gap: { default: '1rem', sm: '1.5rem' } },
        React.createElement(StyledSearchHeaderForm, { onSubmit: handleSubmit },
            React.createElement(StyledSearchHeaderField, { value: searchTermText, name: "search", placeholder: fieldPlaceholder, ref: searchFieldRef, onChange: handleSearchChange }),
            isTouched ? (React.createElement(SearchButton, { ariaLabel: "Submit search", iconType: "search", color: theme.colors.searchBarIconColor })) : (React.createElement(StyledSearchHeaderClearButton, { ariaLabel: "Clear search", color: theme.colors.searchBarIconColor, iconType: "close", type: "reset", onClick: handleClearClick }))),
        React.createElement(TextComponent, { size: "small", fontWeight: "medium", tag: "p" },
            resultsCountText,
            " for",
            ' ',
            React.createElement(TextComponent, { fontWeight: "medium", tag: "span" }, searchTerm))));
};

export { SearchHeader as default };
//# sourceMappingURL=SearchHeader.mjs.map
